import { addToWishList } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { SaveWishListsLineParameter, customSaveWishListLines } from "@NA/Services/ADIAddToListPDP";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { GetProductByIdApiV2Parameter, getProductById } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler<SaveWishListsLineParameter & HasOnSuccess & HasOnComplete, WishListLineModel>;

export const LoadSaveWishListLine: HandlerType = async (props: any) => {
    props.apiResult = await customSaveWishListLines(props.parameter);
    props.parameter.onSuccess();
};

export const SendTrackingCustom: HandlerType = async props => {
    const getproducIdParam: GetProductByIdApiV2Parameter = { id: props.parameter.productId };
    let productModel: ProductModel;
    // eslint-disable-next-line prefer-const
    productModel = await getProductById(getproducIdParam);
    addToWishList([productModel], '', props.parameter.productInfo, props.getState().context.session);
};

export const chain = [LoadSaveWishListLine, SendTrackingCustom];

const saveWishListLine = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        wishListId: "",
        productId: "",
        qtyOrdered: 0,
        unitOfMeasure: "",
        properties: {},
        productInfo: {
            productId: "",
            qtyOrdered: 0,
            unitOfMeasure: "",
            productDetailPath: ""
        },
        onSuccess: () => { },
    },
    "saveWishListLine",
);
export default saveWishListLine;
